import { useState, useEffect, useContext, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { IconButton, Button } from "@mui/material";
import axios from "axios";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { API, PAGE_SIZE, MSG } from "./constantsFront";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { MsgContext } from "../../App";

/**
 * 職員一覧
 * @returns 
 */
function G0181StaffList() {
  let rows = [];
  const [staffList, setStaffList] = useState("");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [authInfo, setAuthInfo] = useState(""); //useContext(AuthInfoContext);

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 職員一覧取得
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    axios.post("/m_staff/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      setStaffList(res.data.dataList);
    });

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // ヘッダー
  const columns = [
    { field: "id", headerName: "職員ID", width: 200 },
    { field: "staff_name", headerName: "職員名", width: 300 },
    { field: "affiliation", headerName: "所属課", width: 300 },
    {
      field: "edit", headerName: "", sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) => <Link to={"/G0182StaffEdit"} state={{ ID: params.id }}><Tooltip title="編集" arrow><IconButton ><EditIcon /></IconButton></Tooltip></Link>
    },
    {
      field: "delete", headerName: "", sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) => <Tooltip title="削除" arrow><IconButton onClick={() => deleteNews(params.id)}><DeleteIcon /></IconButton></Tooltip>
    },
  ];

  // 表示データ
  for (let i in staffList) {
    rows.push({ id: staffList[i].staff_id, staff_name: staffList[i].staff_name, affiliation: staffList[i].affiliation, position: staffList[i].position });
  }

  // 削除ボタン処理
  async function deleteNews(select_id) {
    try {
      if (authInfo.userId == select_id) {
        // return window.confirm("ログイン中のため削除できません");
        return alert("ログイン中のため削除できません");
      }
      if (window.confirm("削除してもよろしいですか？")) {
        console.log("削除処理開始");
        body.staffId = select_id;
        const staffDelete = await axios.post("/m_staff/delete/auth", body);
        if (staffDelete.status === 200) {
          return window.location.reload();
        } else {
          return console.log("削除失敗");
        }
      } else {
        console.log("キャンセル");
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">


              <Container maxWidth="lg">
                <Stack spacing={2}>

                  <h1>職員一覧</h1>

                  <Button component={Link} to={"/G0182StaffEdit"}
                    state={{ ID: -1 }}
                    style={{ width: "200px", color: "white", textDecoration: "none" }}>
                    新規追加
                  </Button>

                  <div style={{ width: "100%" }}>
                    <DataGrid
                      className="DataGrid"
                      columns={columns}
                      rows={rows}
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export default G0181StaffList;